// color design tokens export
export const colorTokens = {
  grey: {
    0: "#FFFFFF", // alt background - taken from figma
    10: "#F7F7F7", // background - taken from figma
    50: "#F0F0F0",
    100: "#E0E0E0",
    200: "#C2C2C2",
    300: "#A3A3A3",
    400: "#858585",
    500: "#666666",
    600: "#4D4D4D",
    700: "#333333",
    800: "#1A1A1A",
    900: "#0A0A0A",
    1000: "#000000",
  },
  primary: {
    50: "#e8f7e8",
    100: "#c8ecc5",
    200: "#a5dfa0",
    300: "#7ed479",
    400: "#5eca59",
    500: "#3dbf38",
    600: "#32b02f",
    700: "#229d22",
    800: "#0e8c14",
    900: "#006d00",
  },
  secondary: {
    50: "#fce8e8",
    100: "#f9c8c8",
    200: "#f5a5a5",
    300: "#f27979",
    400: "#ef5e5e",
    500: "#FB4141",
    600: "#F32D2D",
    700: "#E01A1A",
    800: "#C00B0B",
    900: "#A00000",
  },
};

// mui theme settings

export const themeSettings = (mode) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              dark: colorTokens.primary[200],
              main: colorTokens.primary[300],
              mediumMain: colorTokens.primary[400],
              light: colorTokens.primary[800],
            },
            secondary: {
              dark: colorTokens.secondary[200],
              main: colorTokens.secondary[300],
              mediumMain: colorTokens.secondary[400],
              light: colorTokens.secondary[800],
            },
            neutral: {
              dark: colorTokens.grey[100],
              main: colorTokens.grey[200],
              mediumMain: colorTokens.grey[300],
              medium: colorTokens.grey[400],
              mediumLight: colorTokens.grey[600],
              light: colorTokens.grey[700],
            },
            background: {
              default: colorTokens.grey[900],
              alt: colorTokens.grey[800],
              dark: colorTokens.grey[10],
            },
          }
        : {
            // palette values for light mode
            primary: {
              dark: colorTokens.primary[600],
              main: colorTokens.primary[400],
              mediumMain: colorTokens.primary[300],
              light: colorTokens.primary[50],
            },
            secondary: {
              dark: colorTokens.secondary[600],
              main: colorTokens.secondary[400],
              mediumMain: colorTokens.secondary[300],
              light: colorTokens.secondary[50],
            },
            neutral: {
              dark: colorTokens.grey[700],
              main: colorTokens.grey[500],
              mediumMain: colorTokens.grey[400],
              medium: colorTokens.grey[300],
              mediumLight: colorTokens.grey[100],
              light: colorTokens.grey[50],
            },
            background: {
              default: colorTokens.grey[10],
              alt: colorTokens.grey[0],
              dark: colorTokens.grey[900],
            },
          }),
    },
    typography: {
      fontFamily: ["Inter", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 32,
      },
      h4: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 28,
      },
      h5: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 20,
      },
      h6: {
        fontFamily: ["Inter", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
  };
};
